import moment from 'moment';
import { MOMENT_DEFAULT_DATE_FORMAT } from 'utilities';
import { LTM_QUARTERS, NTM_QUARTERS } from './constants';
import {
  LtmQuartersInputProps,
  NtmQuartersInputProps,
  QuartersReturnProps,
  RecentQuartersInputProps,
  YearQuartersInputProps,
} from './getYearQuarters.props';

export const getYearQuarters = ({ yearKey, fiscalYearData }: YearQuartersInputProps): QuartersReturnProps[] => {
  if (fiscalYearData.years?.[yearKey]) {
    return Object.entries(fiscalYearData.years[yearKey]).map(([name, date]) => ({ name, date }));
  }
  return [];
};

export const getRecentQuarters = ({ fiscalYearData, currentPeriod }: RecentQuartersInputProps): QuartersReturnProps[] =>
  Object.entries(fiscalYearData.years ?? {})
    .filter(([year]) => Number(year) >= currentPeriod.year() - 2 && Number(year) <= currentPeriod.year() + 2)
    .flatMap(([, quarters]) =>
      Object.entries(quarters).map(([name, date]) => ({
        name,
        date: moment(date, MOMENT_DEFAULT_DATE_FORMAT, false),
      }))
    );

export const getLtmQuarters = ({
  proximalQuarters,
  currentPeriod,
  firstQuarterDate,
}: LtmQuartersInputProps): QuartersReturnProps[] => {
  const filteredQuarters = proximalQuarters.filter(
    ({ date: proximalQuarter }) =>
      proximalQuarter.isSameOrBefore(currentPeriod) && proximalQuarter.isAfter(firstQuarterDate)
  );
  return filteredQuarters.map(({ date }, index) => ({
    name: LTM_QUARTERS[index] ?? `LTM Q${index + 1}`,
    date,
  }));
};

export const getNtmQuarters = ({
  proximalQuarters,
  currentPeriod,
  lastQuarterDate,
}: NtmQuartersInputProps): QuartersReturnProps[] => {
  const filteredQuarters = proximalQuarters.filter(
    ({ date: proximalQuarter }) =>
      proximalQuarter.isAfter(currentPeriod) && proximalQuarter.isSameOrBefore(lastQuarterDate)
  );
  return filteredQuarters.map(({ date }, index) => ({
    name: NTM_QUARTERS[index] ?? `NTM Q${index + 1}`,
    date,
  }));
};
